var map = {
	"./blackjack.jpeg": "2bda",
	"./crash.jpeg": "89ff",
	"./mines.jpeg": "1bfd",
	"./new-logo/dice-duel.jpeg": "3f54",
	"./new-logo/slots-game.jpeg": "65fc",
	"./roll.jpeg": "c4df",
	"./towers.jpeg": "2014",
	"./upgrader.jpeg": "ba4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8957";